import classnames from 'classnames';
import React from 'react';

import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

import css from './defaultIconStyles.css';

type Props = IconProps & React.SVGProps<SVGSVGElement>;
export const IconSpecialServices = ({
    width = 20,
    height = 20,
    className,
    ...rest
}: Props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            className={classnames(css.main, css.colored, className)}
            {...rest}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.9624 7.29896L10 4.43557L8.0376 7.29896L4.70792 8.28049L6.82476 11.0317L6.72932 14.5017L10 13.3387L13.2707 14.5017L13.1753 11.0317L15.2921 8.28049L11.9624 7.29896ZM9.10986 8.7748L10 7.47596L10.8902 8.7748L12.4005 9.22003L11.4403 10.468L11.4836 12.042L10 11.5144L8.51642 12.042L8.55971 10.468L7.59951 9.22003L9.10986 8.7748Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.8669 0.272196C10.3459 -0.0907317 9.65405 -0.0907321 9.13309 0.272196L6.67882 1.98197L3.7344 2.50841C3.1094 2.62015 2.62015 3.1094 2.50841 3.7344L1.98197 6.67882L0.272196 9.13309C-0.0907317 9.65405 -0.0907321 10.3459 0.272196 10.8669L1.98197 13.3212L2.50841 16.2656C2.62015 16.8906 3.10939 17.3798 3.7344 17.4916L6.67882 18.018L9.13309 19.7278C9.65405 20.0907 10.3459 20.0907 10.8669 19.7278L13.3212 18.018L16.2656 17.4916C16.8906 17.3798 17.3798 16.8906 17.4916 16.2656L18.018 13.3212L19.7278 10.8669C20.0907 10.3459 20.0907 9.65406 19.7278 9.13309L18.018 6.67882L17.4916 3.7344C17.3798 3.1094 16.8906 2.62016 16.2656 2.50841L13.3212 1.98197L10.8669 0.272196ZM7.74378 3.70449L10 2.13269L12.2562 3.70449C12.4359 3.82968 12.6406 3.91447 12.8562 3.95301L15.563 4.43697L16.047 7.1438C16.0855 7.35939 16.1703 7.56407 16.2955 7.74378L17.8673 10L16.2955 12.2562C16.1703 12.4359 16.0855 12.6406 16.047 12.8562L15.563 15.563L12.8562 16.047C12.6406 16.0855 12.4359 16.1703 12.2562 16.2955L10 17.8673L7.74378 16.2955C7.56407 16.1703 7.35939 16.0855 7.1438 16.047L4.43697 15.563L3.95301 12.8562C3.91447 12.6406 3.82968 12.4359 3.70449 12.2562L2.13269 10L3.70449 7.74378C3.82968 7.56407 3.91447 7.35939 3.95301 7.1438L4.43697 4.43697L7.1438 3.95301C7.35939 3.91447 7.56407 3.82968 7.74378 3.70449Z"
            />
        </svg>
    );
};

export default IconSpecialServices;
